import {get as _get} from 'lodash';

import {columnObjectAlignCenter, columnObjectAlignLeft} from '@utils/tableHelpers';

export const columns = {
    'type': {
        label: 'Type',
        sorting: (row) => row.report_type.name,
        ...columnObjectAlignLeft,
    },
    'scope': {
        label: 'Scope',
        ...columnObjectAlignLeft,
    },
    'incident_source': {
        label: 'Incident source',
        sorting: (row) => _get(row, 'incident_source.name', '-'),
        ...columnObjectAlignLeft,
    },
    'incident_type': {
        label: 'Incident type',
        sorting: (row) => _get(row, 'incident_type.name', '-'),
        ...columnObjectAlignLeft,
    },
    'duration': {
        label: 'Duration',
        sorting: (row) => _get(row, 'incident_duration', '-'),
        header: {
            align: 'right',
        },
        content: {
            align: 'right',
        },
    },
    'downtime': {
        label: 'Downtime',
        sorting: (row) => _get(row, 'count_as_downtime', '-'),
        ...columnObjectAlignCenter,
    },
    'comment': {
        label: 'Comment',
        sorting: (row) => _get(row, 'comment', '-'),
        ...columnObjectAlignCenter,
    },
    'actions': {
        label: 'Actions',
        sorting: false,
        ...columnObjectAlignCenter,
    },
};
